export const env = (): "development" | "test" | "production" => {
  return requireMeta("env") as any;
};
